/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Jgu14Inputs */

const en__field_enum_csjensblank_jgu14 = /** @type {(inputs: _Field_Enum_Csjensblank_Jgu14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Johannes Gutenberg-Universität Mainz`)
};

const de__field_enum_csjensblank_jgu14 = /** @type {(inputs: _Field_Enum_Csjensblank_Jgu14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Johannes Gutenberg-Universität Mainz`)
};

/**
* | output |
* | --- |
* | "Johannes Gutenberg-Universität Mainz" |
*
* @param {_Field_Enum_Csjensblank_Jgu14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_jgu14 = /** @type {((inputs?: _Field_Enum_Csjensblank_Jgu14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Jgu14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_jgu14(inputs)
	return de__field_enum_csjensblank_jgu14(inputs)
});
export { _field_enum_csjensblank_jgu14 as "_field_enum_CSJENSBLANK_JGU" }